function loadScript(src: string): void {
	const script = document.createElement('script');
	script.src = src;
	script.async = true;
	script.defer = true;
	document.head.appendChild(script);
}

async function loadCoreScriptWithVersion(): Promise<void> {
//////////////
	console.log("This is vembed version 1.5");
///////////

	// Load in 2 steps.
	// As the actual loading script may change in the future,
	// we need to load the version first, then load the actual script.
	// The getVersion.php script is used to get the current version of the script.
	try {
		const currentScript = document.currentScript as HTMLScriptElement;
		if (!currentScript) throw new Error('currentScript is null');

		const scriptUrl = new URL(currentScript.src);
		const basePath = scriptUrl.pathname.substring(0, scriptUrl.pathname.lastIndexOf('/') + 1);

		const versionUrl = `${scriptUrl.origin}${basePath}../getVersion.php`;
		const response = await fetch(versionUrl, { cache: 'no-cache' });

		if (!response.ok) {
			throw new Error(`Failed to fetch version: ${response.statusText}`);
		}

		const version = (await response.text()).trim();
		const coreScriptUrl = `${scriptUrl.origin}${basePath}vembed_core.js?v=${encodeURIComponent(version)}`;

		loadScript(coreScriptUrl);
	} catch (err) {
		console.error('Failed to load vembed_core.js:', err);
	}
}

loadCoreScriptWithVersion();
